import * as React from "react";

import { cn } from "../../lib/utils";
import {
  PLATFORM_LOGO_COMPACT_DARK_URL,
  PLATFORM_LOGO_COMPACT_LIGHT_URL,
  PLATFORM_LOGO_HORIZONTAL_DARK_URL,
  PLATFORM_LOGO_HORIZONTAL_LIGHT_URL,
  PLATFORM_LOGO_ICON_URL,
} from "../../lib/brand-assets";

type BrandLogoProps = {
  tenantLogoUrl?: string | null;
  tenantName?: string | null;
  variant?: "compact" | "horizontal" | "icon";
  className?: string;
  imageClassName?: string;
};

export function BrandLogo({
  tenantLogoUrl,
  tenantName,
  variant = "compact",
  className,
  imageClassName,
}: BrandLogoProps) {
  const alt = tenantLogoUrl
    ? `${tenantName?.trim() || "Tenant"} logo`
    : variant === "icon"
      ? "Ibada Cloud icon"
      : "Ibada Cloud logo";

  if (tenantLogoUrl) {
    return (
      <div className={cn("relative block shrink-0", className)}>
        <img
          src={tenantLogoUrl}
          alt={alt}
          className={cn("h-full w-full object-contain", imageClassName)}
        />
      </div>
    );
  }

  if (variant === "icon") {
    return (
      <div className={cn("relative block shrink-0", className)}>
        <img
          src={PLATFORM_LOGO_ICON_URL}
          alt={alt}
          className={cn("h-full w-full object-contain", imageClassName)}
        />
      </div>
    );
  }

  if (variant === "horizontal") {
    return (
      <div className={cn("relative block shrink-0", className)}>
        <img
          src={PLATFORM_LOGO_HORIZONTAL_LIGHT_URL}
          alt={alt}
          className={cn("h-full w-full object-contain dark:hidden", imageClassName)}
        />
        <img
          src={PLATFORM_LOGO_HORIZONTAL_DARK_URL}
          alt={alt}
          className={cn("hidden h-full w-full object-contain dark:block", imageClassName)}
        />
      </div>
    );
  }

  return (
    <div className={cn("relative block shrink-0", className)}>
      <img
        src={PLATFORM_LOGO_COMPACT_LIGHT_URL}
        alt={alt}
        className={cn("h-full w-full object-contain dark:hidden", imageClassName)}
      />
      <img
        src={PLATFORM_LOGO_COMPACT_DARK_URL}
        alt={alt}
        className={cn("hidden h-full w-full object-contain dark:block", imageClassName)}
      />
    </div>
  );
}
